<template>
  <div class="page-table projeTanim  mainDiv mb-30" id="affix-container">
    <div class="animated fadeInUp card-base baslikBg">Yatırım Güncelle</div>
    <el-row :gutter="10" v-loading="loading" :element-loading-text='"Yatırım Detayı Yükleniyor. Lütfen Bekleyiniz."'
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-form status-icon :model="projeForm" :rules="rulesProje" ref="projeForm" class="demo-ruleForm">
        <el-col :lg="18" :md="18" :sm="24" :xs="24">
          <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft pb-20 pt-10">
            <el-row>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Yatırımcı Adı" prop="musteriID">
                  <el-select style="width: 100%" size="small" auto-complete="off"
                             v-model="projeForm.musteriID" placeholder="Yatırımcı Seçiniz" filterable
                             :filter-methos="filterMethod">
                    <el-option v-for="item in musteriler" aria-autocomplete="none" :key="item.musteriID"
                               :label="item.musteriAdi" :value="item.musteriID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Proje Adı" prop="projeBaslik">
                  <el-input auto-complete="off" size="small" v-model="projeForm.projeBaslik"
                            :placeholder="'Proje Adı Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Yatırım Tutarı" prop="yatirimTutari">
                  <el-input auto-complete="off" size="small" @input="formaData('yatirimTutari')"
                            v-model="projeForm.yatirimTutari" :placeholder="'Yatırım Tutarı'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                <el-form-item label="İstihdam Sayısı" prop="istihdamSayisi">
                  <el-input auto-complete="off" size="small" v-model="projeForm.istihdamSayisi"
                            :placeholder="'İstihdam Sayısı Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Alan" prop="alan">
                  <el-input auto-complete="off" size="small" @input="formaData('alan')"
                            v-model="projeForm.alan" :placeholder="'Alan Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Ada" prop="ada">
                  <el-input auto-complete="off" size="small" v-mask="'##############'"
                            v-model="projeForm.ada" :placeholder="'Ada Giriniz'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Parsel" prop="parsel">
                  <el-input auto-complete="off" size="small" @input="validateParsel"
                            v-model="projeForm.parsel" :placeholder="'Parsel Giriniz'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--
            <el-row>
                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                    <el-form-item label="Ülke" prop="ulkeID">
                        <el-select style="width: 100%" size="small" v-model="projeForm.ulkeID"
                            @change="getIlListesi" placeholder="Ülke Seçiniz" filterable
                            :filter-methos="filterMethod">
                            <el-option v-for="item in ulkeler" :key="item.ulkeID" :label="item.ulkeAdi"
                                :value="item.ulkeID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                    <el-form-item label="İl" prop="ilID">
                        <el-select style="width: 100%" size="small" v-model="projeForm.ilID"
                            @change="getIlceListesi" placeholder="İl Seçiniz" filterable
                            :filter-methos="filterMethod">
                            <el-option v-for="item in iller" :key="item.ilID" :label="item.ilBaslik"
                                :value="item.ilID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                    <el-form-item label="İlçe" prop="ilceID">
                        <el-select style="width: 100%" size="small" v-model="projeForm.ilceID"
                            placeholder="İlçe Seçiniz" filterable :filter-methos="filterMethod">
                            <el-option v-for="item in ilceler" :key="item.ilceID" :label="item.ilceBaslik"
                                :value="item.ilceID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row> -->
            <el-row>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Adres" prop="adresBaslik">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                            placeholder="Adres Giriniz" v-model="projeForm.adresBaslik">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                <el-form-item label="Not" prop="not">
                  <el-input type="textarea" auto-complete="off" :autosize="{ minRows: 2 }"
                            placeholder="Not" v-model="projeForm.not">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :lg="6" :md="6" :sm="24" :xs="24">
          <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
            <el-collapse-item class="card-shadow--medium pt-10" name="8"
                              :title='$t("src.views.apps.genel.durum")'>
              <el-row>
                <!--                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">-->
                <!--                  <el-form-item prop="durum">-->
                <!--                    <el-select size="small" :disabled="disabled" v-model="projeForm.durum"-->
                <!--                               :placeholder='$t("src.views.apps.messages.addBultenTitle")' style="width: 100%">-->
                <!--                      <el-option value="0" :label='$t("src.views.apps.durum.yatirim.onay")'></el-option>-->
                <!--                      <el-option value="1"-->
                <!--                                 :label='$t("src.views.apps.durum.yatirim.aktif")'></el-option>-->
                <!--                      <el-option value="2"-->
                <!--                                 :label='$t("src.views.apps.durum.yatirim.askiyaAl")'></el-option>-->
                <!--                    </el-select>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
                <el-button size="mini" v-on:click="projeGuncelle('projeForm', projeForm.durum)"
                           class="onayBtn" type="primary">
                  <label>Kaydet</label>
                </el-button>
                <el-popover placement="bottom" width="300" v-model="visibleSil">
                  <p>{{ $t('src.views.apps.messages.clearFormAlert') }}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="primary" @click="resetForm('projeForm')">
                      {{ $t('src.views.apps.genel.yes') }}
                    </el-button>
                    <el-button size="mini" @click="visibleSil = false;">
                      {{ $t('src.views.apps.genel.no') }}
                    </el-button>
                  </div>
                  <el-button size="mini" slot="reference">
                    {{ $t('src.views.apps.genel.temizle') }}
                  </el-button>
                </el-popover>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-col>
        <el-col :span="24" class="yatirim-guncelle-tarih-col">
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card disabled-tarih">
              <div class="top-row-line"/>
              <h4>Yönetim Tarihi</h4>
              <el-tooltip effect="dark"
                          content="Yönetim tarihi revizyon edilemez !" placement="top">
                <i class="mdi mdi-information mdi-18px information-icon"></i>
              </el-tooltip>
              <h4 style="height: 20px;" :style="{color : getDayInfo(farklar.normal.yonetim).gecti ? '#FF204E' :''}">
                ({{ getDayInfo(farklar.normal.yonetim).text }} )</h4>
              <el-form-item>
                <el-date-picker disabled v-model="projeForm.tarihler.yonetimTarihi" size="small" class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                </el-date-picker>
              </el-form-item>
              <el-row class="text-center p-10 mt-5 revizyon-btn-row"/>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card disabled-tarih">
              <div class="top-row-line"/>
              <h4>Tebligat Tarihi</h4>
              <el-tooltip effect="dark"
                          content="Tebligat tarihi revizyon edilemez !" placement="top">
                <i class="mdi mdi-information mdi-18px information-icon"></i>
              </el-tooltip>
              <h4 style="height: 20px;" :style="{color : getDayInfo(farklar.normal.tebligat).gecti ? '#FF204E' :''}">
                ({{ getDayInfo(farklar.normal.tebligat).text }} )</h4>
              <el-form-item>
                <el-date-picker disabled v-model="projeForm.tarihler.tebligatTarihi" size="small" class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                </el-date-picker>
              </el-form-item>
              <el-row class="text-center p-10 mt-5 revizyon-btn-row"/>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card disabled-tarih">
              <div class="top-row-line"/>
              <h4>Noter Tarihi</h4>
              <el-tooltip effect="dark"
                          content="Noter tarihi revizyon edilemez !" placement="top">
                <i class="mdi mdi-information mdi-18px information-icon"></i>
              </el-tooltip>
              <h4 style="height: 20px;" :style="{color : getDayInfo(farklar.normal.noter).gecti ? '#FF204E' :''}">
                ({{ getDayInfo(farklar.normal.noter).text }} )</h4>
              <el-form-item>
                <el-date-picker disabled v-model="projeForm.tarihler.noterTarihi" size="small" class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                </el-date-picker>
              </el-form-item>
              <el-row class="text-center p-10 mt-5 revizyon-btn-row"/>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card" :class="farklar.revizyon.arsaTahsis && 'disabled-tarih'">
              <div class="top-row-line dange-line"/>
              <h4>Arsa Tahsis Tarihi</h4>
              <h4 style="height: 20px;"
                  :style="{color : getDayInfo(farklar.normal.arsaTahsis).gecti && !revizyon.arsaTahsis ? '#FF204E' :''}">
                ( {{ !revizyon.arsaTahsis ? getDayInfo(farklar.normal.arsaTahsis).text : '' }} )
              </h4>
              <el-form-item>
                <el-date-picker :disabled="serverDate.arsaTahsis" v-model="updateDates.arsaTahsis" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                </el-date-picker>
              </el-form-item>
              <el-row class="text-center p-10 mt-5 revizyon-btn-row">
                <el-button v-if="serverDate.arsaTahsis && !revizyon.arsaTahsis" @click="revizyonAc('arsaTahsis')"
                           size="mini"
                           icon="el-icon-plus">Revizyon
                </el-button>
              </el-row>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card" :class="farklar.revizyon.yapiRuhsat && 'disabled-tarih'">
              <div class="top-row-line"/>
              <h4>Yapı Ruhsat Tarihi</h4>
              <h4 style="height: 20px;"
                  :style="{color : getDayInfo(farklar.normal.yapiRuhsat).gecti && !revizyon.yapiRuhsat ? '#FF204E' :''}">
                ( {{ !revizyon.yapiRuhsat ? getDayInfo(farklar.normal.yapiRuhsat).text : '' }} ) </h4>
              <el-form-item>
                <el-date-picker :disabled="serverDate.yapiRuhsat" v-model="updateDates.yapiRuhsat" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                </el-date-picker>
              </el-form-item>
              <el-row class="text-center p-10 mt-5 revizyon-btn-row">
                <el-button v-if="serverDate.yapiRuhsat && !revizyon.yapiRuhsat" @click="revizyonAc('yapiRuhsat')"
                           size="mini"
                           icon="el-icon-plus">Revizyon
                </el-button>
              </el-row>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card" :class="farklar.revizyon.isYeriAcma && 'disabled-tarih'"
                     :style="{border : !updateDates.isYeriAcma ?'3px solid red':'none'}">
              <div v-if="updateDates.isYeriAcma" class="top-row-line"/>
              <div v-else class="top-row-line-space"/>
              <h4>İş Yeri Açma Ruhsat Tarihi</h4>
              <h4 style="height: 20px;"
                  :style="{color : getDayInfo(farklar.normal.isYeriAcma).gecti && !revizyon.isYeriAcma ? '#FF204E' :''}">
                ( {{ !revizyon.isYeriAcma ? getDayInfo(farklar.normal.isYeriAcma).text : '' }} )
              </h4>
              <el-form-item>
                <el-date-picker :disabled="serverDate.isYeriAcma" v-model="updateDates.isYeriAcma" size="small"
                                class="select-wide"
                                type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                </el-date-picker>
              </el-form-item>
              <el-row class="text-center p-10 mt-5 revizyon-btn-row">
                <el-button v-if="serverDate.isYeriAcma && !revizyon.isYeriAcma" @click="revizyonAc('isYeriAcma')"
                           size="mini"
                           icon="el-icon-plus">Revizyon
                </el-button>
              </el-row>
            </el-card>
          </el-col>
        </el-col>
        <el-col v-if="revizyon.yapiRuhsat || revizyon.arsaTahsis || revizyon.isYeriAcma" :span="24" class="mt-20">
          <el-divider content-position="center" class="revizyon-date-divider">
            Revizyon Tarihleri
          </el-divider>
        </el-col>
        <el-col :span="24" class="yatirim-guncelle-tarih-col">
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card revizyon-card border-none"/>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card revizyon-card border-none"/>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card border-none"/>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card revizyon-card">
              <div v-if="revizyon.arsaTahsis">
                <div class="top-row-line"/>
                <el-divider content-position="center">Revizyon</el-divider>
                <h4>Arsa Tahsis Tarihi</h4>
                <h4 style="height: 20px;"
                    :style="{color : getDayInfo(farklar.revizyon.arsaTahsis).gecti ? '#FF204E' :''}">
                  ( {{ getDayInfo(farklar.revizyon.arsaTahsis).text }} )
                </h4>
                <el-form-item style="margin-bottom: 20px;">
                  <el-date-picker v-model="projeForm.tarihler.guncellenenArsaTahsisTarihi" size="small"
                                  class="select-wide" :clearable="false"
                                  type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                  value-format="yyyy-MM-dd" :picker-options="datePickerOptions('arsaTahsis')">
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card revizyon-card">
              <div v-if="revizyon.yapiRuhsat">
                <div class="top-row-line"/>
                <el-divider content-position="center">Revizyon</el-divider>
                <h4>Yapı Ruhsat Tarihi</h4>
                <h4 style="height: 20px;"
                    :style="{color : getDayInfo(farklar.revizyon.yapiRuhsat).gecti ? '#FF204E' :''}">
                  ( {{ farklar.revizyon.yapiRuhsat || projeForm.tarihler.guncellenenYapiRuhsatTarihi && getDayInfo(farklar.revizyon.yapiRuhsat || projeForm.tarihler.guncellenenYapiRuhsatTarihi).text }} )
                </h4>
                <el-form-item style="margin-bottom: 20px;">
                  <el-date-picker v-model="projeForm.tarihler.guncellenenYapiRuhsatTarihi" size="small"
                                  class="select-wide" :clearable="false"
                                  type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                  value-format="yyyy-MM-dd" :picker-options="datePickerOptions('yapiRuhsat')">
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
          <el-col :lg="3" :md="6" :sm="12" :xs="12">
            <el-card class="arsa-tarih-card revizyon-card">
              <div v-if="revizyon.isYeriAcma">
                <div class="top-row-line"/>
                <el-divider content-position="center">Revizyon</el-divider>
                <h4>İş Yeri Açma Ruhsat Tarihi</h4>
                <h4 style="height: 20px;"
                    :style="{color : getDayInfo(farklar.revizyon.isYeriAcma).gecti ? '#FF204E' :''}">
                  ( {{ getDayInfo(farklar.revizyon.isYeriAcma).text }} )
                </h4>
                <el-form-item style="margin-bottom: 20px;">
                  <el-date-picker v-model="projeForm.tarihler.guncellenenIsYeriAcmaRuhsatTarihi" size="small"
                                  class="select-wide" :clearable="false"
                                  type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                  value-format="yyyy-MM-dd" :picker-options="datePickerOptions('isYeriAcma')">
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-card>
          </el-col>
        </el-col>
      </el-form>
    </el-row>
  </div>
</template>
<script>
import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
import musteriService from '../../../WSProvider/MusteriService'
import projeService from '../../../WSProvider/ProjeService'
import notification from '../../../notification'
import functions from '../../../functions'
import EventBus from '@/components/event-bus'

var moment = require('moment');
let time = moment().format('YYYY-MM-DD');

export default {
  name: "YatirimGuncelle",
  components: {},
  watch: {
    '$store.state.lastProjectUpdateId': function (newVal) {
      this.sayfaKapat('yatirimguncelle')
      this.$nextTick(() => {
        functions.routeSayfa("Yatırım Güncelle", this)
      })
      this.projeForm.projeID = newVal
      this.getProjeDetay();
    },
  },
  created() {
    this.checkDevice();
  },
  mounted() {
    window.addEventListener('resize', this.checkDevice);
    this.projeForm.projeID = this.$store.getters.getLastProjectUpdateId
    this.getProjeDetay();
    this.getMusteriListesi();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  data() {
    return {
      updateDates: {
        arsaTahsis: null,
        yapiRuhsat: null,
        isYeriAcma: null,
      },
      serverDate: {
        arsaTahsis: null,
        yapiRuhsat: null,
        isYeriAcma: null,
      },
      isDesktop: false,
      projeData: {},
      musteriler: [],
      ulkeler: [],
      iller: [],
      ilceler: [],
      tumunuSec: false,
      loading: false,
      selectedImagesFromServer: [],
      path: projeService.path,
      imagePath: projeService.imagePath,
      belgePath: projeService.belgePath,
      editor: ClassicEditor,
      editorConfig: {
        language: 'tr',
      },
      activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      visibleSil: false,
      disabled: false,
      options: [],
      dateRangeOptions: {
        firstDayOfWeek: 1
      },
      projeForm: {
        projeID: '',
        not: '',
        // musteriAdi: '',
        projeBaslik: '',
        alan: '',
        ada: '',
        parsel: '',
        musteriID: '',
        adresBaslik: '',
        // durum: '1',
        yatirimTutari: '',
        istihdamSayisi: '',
        tarihler: {
          yonetimTarihi: '',
          tebligatTarihi: '',
          noterTarihi: '',
          arsaTahsisTarihi: '',
          guncellenenArsaTahsisTarihi: '',
          guncellenenYapiRuhsatTarihi: '',
          guncellenenIsYeriAcmaRuhsatTarihi: '',
        },
      },
      selectIcon: '1',
      page: 0,
      postPage: 0,
      sizes: 10,
      rulesProje: {
        projeBaslik: [{
          required: true,
          message: "Lütfen Yatirim Adı Giriniz",
          trigger: 'blur'
        }],
        musteriID: [{
          required: true,
          message: "Lütfen Firma Seçiniz",
          trigger: 'blur'
        }],
        alan: [{
          required: true,
          message: "Lütfen Alan Giriniz",
          trigger: 'blur'
        }],
        ada: [{
          required: true,
          message: "Lütfen Ada Giriniz",
          trigger: 'blur'
        }],
        parsel: [{
          required: true,
          message: "Lütfen Parsel Giriniz",
          trigger: 'blur'
        }],
        adresBaslik: [{
          required: true,
          message: "Lütfen Adres Giriniz",
          trigger: 'blur'
        }],
        yatirimTutari: [{
          required: true,
          message: "Lütfen Yatırım Tutarı Giriniz",
          trigger: 'blur'
        }],
        istihdamSayisi: [{
          required: true,
          message: "Lütfen İstihdam Sayısı Giriniz",
          trigger: 'blur'
        }]
      },
      revizyon: {
        arsaTahsis: false,
        yapiRuhsat: false,
        isYeriAcma: false,
      },
      farklar: {
        normal: {
          yonetim: '',
          tebligat: '',
          noter: '',
          arsaTahsis: '',
          yapiRuhsat: '',
          isYeriAcma: '',
        },
        revizyon: {
          arsaTahsis: '',
          yapiRuhsat: '',
          isYeriAcma: '',
        },
      },
    }
  },
  methods: {
    getDayInfo(tarih) {
      if (!tarih.toString().includes('-')) return {
        text: tarih + ' Gün Kaldı',
        gecti: false
      }
      else return {
        text: tarih + ' Gün Geçti',
        gecti: true
      }
    },
    datePickerOptions(tur) {
      const self = this
      return {
        firstDayOfWeek: 1,
        disabledDate: date => {
          if (tur == 'noter') {
            let noterMinTarih = new Date(self.projeForm.tarihler.tebligatTarihi)
            return date < noterMinTarih
          }
          if (tur == 'arsaTahsis') {
            let arsaMinTarih = new Date(self.projeForm.tarihler.tebligatTarihi)
            return date < arsaMinTarih
          }
          if (tur == 'yapiRuhsat') {
            let arsaTarih = !this.revizyon.arsaTahsis ? new Date(self.projeForm.tarihler.arsaTahsisTarihi) : new Date(self.projeForm.tarihler.guncellenenArsaTahsisTarihi)
            let yapiMinTarih = new Date(self.projeForm.tarihler.tebligatTarihi)
            return date < yapiMinTarih || date < arsaTarih
          }
          if (tur == 'isYeriAcma') {
            let yapiRuhsatTarih = !this.revizyon.yapiRuhsat ? new Date(self.projeForm.tarihler.yapiRuhsatTarihi) : new Date(self.projeForm.tarihler.guncellenenYapiRuhsatTarihi)
            let isYeriAcmaMaxTarih = new Date(moment(yapiRuhsatTarih).add(730, 'days').format('YYYY-MM-DD'))
            return date < yapiRuhsatTarih || date > isYeriAcmaMaxTarih
          }
        }
      };
    },
    revizyonAc(tur) {
      this.revizyon[tur] = true
    },
    formaData(nameOfData) {
      return false
      this.projeForm[nameOfData] = this.projeForm[nameOfData].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    checkDevice() {
      this.isDesktop = window.innerWidth >= 821;
    },
    validateParsel() {
      const regex = /^[0-9!@#\$%\^\&*\)\(+=._-]+$/;
      if (!regex.test(this.projeForm.parsel)) {
        this.projeForm.parsel = this.projeForm.parsel.replace(/[^0-9!@#\$%\^\&*/\)\(+=._-]+$/, '');
      }
    },
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    },
    refreshPage() {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.stateLoading = false;
      this.getMusteriListesi();
      this.getUlkeListesi();
    },
    getMusteriListesi() {
      try {
        this.loading = true;
        musteriService.getCustomerListUnlimited().then((response) => {
          localStorage.setItem("userDataDemirag", response.token)
          if (response.status == 200) {
            this.musteriler = response.data;
          }
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.musteriler = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        // notification.Status("success", this, "An error occurred while fetching the customer list.")
        this.loading = false
      }
    },
    getUlkeListesi() {
      try {
        this.loading = true;
        projeService.ulkeGetir().then((response) => {
          localStorage.setItem("userDataDemirag", response.token)
          if (response.status == 200) {
            this.ulkeler = response.data;
          }
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.ulkeler = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        // notification.Status("success", this, "An error occurred while fetching the customer list.")
        this.loading = false
      }
    },
    getProjeDetay() {
      try {
        this.loading = true;
        projeService.projeDetay(this.projeForm.projeID).then(response => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            this.projeForm.musteriAdi = response.data.musteriAdi
            this.projeForm.musteriID = response.data.musteriID
            this.projeForm.projeBaslik = response.data.projeBaslik
            this.projeForm.alan = response.data.alan
            this.projeForm.ada = response.data.ada
            this.projeForm.parsel = response.data.parsel
            this.projeForm.adresBaslik = response.data.adres
            this.projeForm.istihdamSayisi = response.data.istihdamSayisi
            this.projeForm.not = response.data.bilgi
            this.projeForm.yatirimTutari = response.data.tutar
            this.projeData = response.data
            // ? tarihler
            this.projeForm.tarihler.yonetimTarihi = response.data.yonetimTarihi
            this.projeForm.tarihler.tebligatTarihi = response.data.tebligatTarihi
            this.projeForm.tarihler.noterTarihi = response.data.noterTarihi
            this.projeForm.tarihler.arsaTahsisTarihi = response.data.arsaTahsisTarihi
            this.projeForm.tarihler.yapiRuhsatTarihi = response.data.yapiRuhsatTarihi
            this.projeForm.tarihler.isYeriAcmaRuhsatTarihi = response.data.isYeriAcmaRuhsatTarihi

            this.updateDates.arsaTahsis = response.data.arsaTahsisTarihi
            this.updateDates.yapiRuhsat = response.data.yapiRuhsatTarihi
            this.updateDates.isYeriAcma = response.data.isYeriAcmaRuhsatTarihi

            if (response.data.arsaTahsisTarihi != null) this.serverDate.arsaTahsis = true
            else this.serverDate.arsaTahsis = false
            if (response.data.yapiRuhsatTarihi != null) this.serverDate.yapiRuhsat = true
            else this.serverDate.yapiRuhsat = false
            if (response.data.isYeriAcmaRuhsatTarihi != null) this.serverDate.isYeriAcma = true
            else this.serverDate.isYeriAcma = false

            // ? revizyon tarihleri
            this.projeForm.tarihler.guncellenenArsaTahsisTarihi = response.data.guncellenenArsaTahsisTarihi
            this.projeForm.tarihler.guncellenenYapiRuhsatTarihi = response.data.guncellenenYapiRuhsatTarihi
            this.projeForm.tarihler.guncellenenIsYeriAcmaRuhsatTarihi = response.data.guncellenenIsYeriAcmaRuhsatTarihi

            this.farklar.normal.yonetim = getDays(time, response.data.yonetimTarihi)
            this.farklar.normal.tebligat = getDays(time, response.data.tebligatTarihi)
            this.farklar.normal.noter = getDays(time, response.data.noterTarihi)

            if (response.data.guncellenenArsaTahsisTarihi != null) {
              this.revizyon.arsaTahsis = true
              this.farklar.revizyon.arsaTahsis = getDays(time, response.data.guncellenenArsaTahsisTarihi)
            } else {
              this.farklar.normal.arsaTahsis = getDays(time, response.data.arsaTahsisTarihi)
            }
            if (response.data.guncellenenYapiRuhsatTarihi != null) {
              this.revizyon.yapiRuhsat = true
              this.farklar.revizyon.yapiRuhsat = getDays(time, response.data.guncellenenYapiRuhsatTarihi)
            } else {
              this.farklar.normal.yapiRuhsat = getDays(time, response.data.yapiRuhsatTarihi)
            }
            if (response.data.guncellenenIsYeriAcmaRuhsatTarihi != null) {
              this.revizyon.isYeriAcma = true
              this.farklar.revizyon.isYeriAcma = getDays(time, response.data.guncellenenIsYeriAcmaRuhsatTarihi)
            } else {
              this.farklar.normal.isYeriAcma = getDays(time, response.data.isYeriAcmaRuhsatTarihi)
            }
          }
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          this.loading = false;
        })
      } catch (e) {
        this.loading = false;
      }
    },
    projeGuncelle(formName) {
      const arsaTahsisTarih = this.projeForm.tarihler.guncellenenArsaTahsisTarihi
      const yapiRuhsatTarih = this.projeForm.tarihler.guncellenenYapiRuhsatTarihi
      const isYeriAcmaTarihi = this.projeForm.tarihler.guncellenenIsYeriAcmaRuhsatTarihi
      const dates = {
        // ? hepsini gondermek yerine sadece gerekli olanı gonderir
        // [this.serverDate.arsaTahsis ? this.revizyon.arsaTahsis ? 'data[guncellenenArsaTahsisTarihi]' : 'data[arsaTahsisTarihi]' : 'data[arsaTahsisTarihi]']: this.serverDate.arsaTahsis ? arsaTahsisTarih != null ? arsaTahsisTarih : this.updateDates.arsaTahsis : this.updateDates.arsaTahsis,
        // [this.serverDate.yapiRuhsat ? this.revizyon.yapiRuhsat ? 'data[guncellenenYapiRuhsatTarihi]' : 'data[yapiRuhsatTarihi]' : 'data[yapiRuhsatTarihi]']: this.serverDate.yapiRuhsat ? yapiRuhsatTarih != null ? yapiRuhsatTarih : this.updateDates.yapiRuhsat : this.updateDates.yapiRuhsat,
        // [this.serverDate.isYeriAcma ? this.revizyon.isYeriAcma ? 'data[guncellenenIsYeriAcmaRuhsatTarihi]' : 'data[isYeriAcmaRuhsatTarihi]' : 'data[isYeriAcmaRuhsatTarihi]']: this.serverDate.isYeriAcma ? isYeriAcmaTarihi != null ? isYeriAcmaTarihi : this.updateDates.isYeriAcma : this.updateDates.isYeriAcma,
        ['data[yonetimTarihi]']: this.projeForm.tarihler.yonetimTarihi || '',
        ['data[tebligatTarihi]']: this.projeForm.tarihler.tebligatTarihi || '',
        ['data[noterTarihi]']: this.projeForm.tarihler.noterTarihi || '',
        ['data[guncellenenArsaTahsisTarihi]']: arsaTahsisTarih || '',
        ['data[guncellenenYapiRuhsatTarihi]']: yapiRuhsatTarih || '',
        ['data[guncellenenIsYeriAcmaRuhsatTarihi]']: isYeriAcmaTarihi || '',
        ['data[arsaTahsisTarihi]']: this.updateDates.arsaTahsis || '',
        ['data[yapiRuhsatTarihi]']: this.updateDates.yapiRuhsat || '',
        ['data[isYeriAcmaRuhsatTarihi]']: this.updateDates.isYeriAcma || '',
      }
      const userDataDemirag = localStorage.getItem('userDataDemirag');
      const param = {
        token: userDataDemirag,
        'data[projeID]': this.projeForm.projeID,
        'data[not]': this.projeForm.not,
        'data[projeBaslik]': this.projeForm.projeBaslik,
        'data[alan]': this.projeForm.alan,
        'data[ada]': this.projeForm.ada,
        'data[parsel]': this.projeForm.parsel,
        'data[musteriID]': this.projeForm.musteriID,
        'data[adres]': this.projeForm.adresBaslik,
        'data[tutar]': this.projeForm.yatirimTutari,
        'data[istihdamSayisi]': this.projeForm.istihdamSayisi,
        serviceName: 'proje',
        methodName: 'projeDuzenle',
      };
      this.$refs[formName].validate((valid, errors) => {
        if (valid) {
          this.$confirm("Yatırımı güncellemek istediğinize emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
            confirmButtonText: this.$t("src.views.apps.genel.yes"),
            cancelButtonText: this.$t("src.views.apps.genel.no"),
            type: 'warning'
          }).then(() => {
            this.loading = true;
            projeService.projeGuncelle({...param, ...dates}).then((response) => {
              if (response.status == 200) {
                localStorage.setItem("userDataDemirag", response.token)
                notification.Status("success", this, response.msg)
                // EventBus.$emit("cariList", true)
                EventBus.$emit("yatirimListesi", '1')
                functions.sayfaKapat("yatirimguncelle", this);
                this.$store.commit('changeProjeUpdateData', null)
                this.resetForm(formName)
              }
              this.loading = false;
            }).catch(err => {
              if (err.responseJSON) {
                let error = err.responseJSON
                if (error.status == 401) {
                  notification.Status(150, this);
                } else notification.Status("errorMsg", this, error.errMsg)
              } else {
                //notification.Status(503, this)
              }
              this.loading = false;
            })
          }).catch((e) => {
            this.loading = false;
          })
        } else {
          for (var k in errors) {
            errors[k].forEach((element) => {
              notification.Status("warning", this, element.message);
            })
            this.loading = false
          }
        }
      })
    },
    indexMethod(index) {
      return ((this.page - 1) * 10) + index + 1;
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getMusteriListesi();
      this.getUlkeListesi();
    },
    handleChange(event) {
      this.selectIcon = event;
      this.page = 1;
      this.postPage = 0;
      this.getMusteriListesi();
      this.getUlkeListesi();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      this.getMusteriListesi();
      this.getUlkeListesi();
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visibleSil = false;
    },
  }
}

function getDays(tarih1, tarih2) {
  const tarih1Moment = moment(tarih1);
  const tarih2Moment = moment(tarih2);
  const gunFarki = tarih2Moment.diff(tarih1Moment, 'days');
  if (!isNaN(gunFarki)) return gunFarki
  else return 'Tarih Seçilmedi'
}
</script>
<style scoped lang="scss">

.information-icon {
  position: absolute !important;
  right: 5px !important;
  top: 5px !important;
}

.warning {
  border: 2px solid #ffa6a6;
  background-color: #ffe7e7;
  box-shadow: inset 0px 0px 9px 0px red;
}

.warning.warningAnimation {
  animation-name: emptyFileWarning;
  animation-iteration-count: infinite;
}

@keyframes emptyFileWarning {
  0% {
    box-shadow: inset 0px 0px 2px 0px red;
  }

  50% {
    box-shadow: inset 0px 0px 8px 0px red;
  }

  100% {
    box-shadow: inset 0px 0px 2px 0px red;
  }
}

</style>
<style lang="scss">
.revizyon-date-divider div {
  font-size: 18px !important
}

.yatirim-guncelle-tarih-col {
  padding: 0 !important;

  .border-none {
    border: none;
  }

  .revizyon-btn-row {
    height: 43px;
    padding: 5px 11px;
  }

  .revizyon-card {
    .dange-line {
      background-color: red !important;
    }

    .top-row-line {
      background-color: #47A992 !important;
    }
  }

  .disabled-tarih {
    h4 {
      color: gray;
    }

    .top-row-line {
      background-color: #c8c8c8 !important;
    }
  }

  .arsa-tarih-card {
    position: relative;
    border: none;
    margin-top: 20px;

    .el-button--mini {
      padding: 4px 11px;
    }

    .top-row-line-space {
      margin: 0 0 20px 0;
    }

    .top-row-line {
      height: 5px;
      background-color: #21b8c8;
      margin: 0 0 20px 0;
    }

    .el-card__body {
      padding: 0 0 0 0 !important;

      .el-form-item {
        margin: 0;
        padding: 10px 15px 0 15px;
      }

      h4 {
        text-align: center;
        margin: 0;
      }
    }
  }
}
</style>
<style>
.flex-box {
  display: flex;
  justify-content: flex-end;
}

.kapsamlar .el-collapse-item .el-collapse-item__header {
  color: white;
  text-align: center;
  font-size: 15px !important;
  padding: 0px 10px;
  font-weight: 400;
  border-radius: 8px;
}

.kapsamlar .el-collapse-item:nth-child(1) .el-collapse-item__header {
  background-color: #28323b;
}

.kapsamlar .el-collapse-item:nth-child(2) .el-collapse-item__header {
  background-color: #006cae;
}

.kapsamlar .el-collapse-item:nth-child(3) .el-collapse-item__header {
  background-color: #3595cf;
}

.kapsamlar .el-collapse-item:nth-child(4) .el-collapse-item__header {
  background-color: #ff8b00;
}
</style>